<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" size="small" type="primary" class="chaxun"
          >查询列表</Button
        ><Button @click="dayin" size="small" type="error" class="chaxun"
          >打印工单</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectTableData = $event"
    >
      <viewer slot-scope="{ row, index }" :slot="'jiaodi'">
        <img
          v-for="(y, index1) in row.handoverFileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
      <viewer slot-scope="{ row, index }" :slot="'shenpi'">
        <img
          v-for="(y, index1) in row.approveFileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
      <viewer slot-scope="{ row, index }" :slot="'action'">
        <img
          v-for="(y, index1) in row.fileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <docDetail v-if="false" ref="docDetail"></docDetail>
    <dayin ref="dayin"></dayin>
  </div>
</template>
<script>
import dayin from "./dayin.vue";
import docDetail from "../yhgl/docDetail.vue";
export default {
  components: { docDetail, dayin },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
        },
        { title: "申请单号", key: "workNo", maxWidth: 300, minWidth: 100 },
        { title: "项目名称", key: "name", maxWidth: 300, minWidth: 100 },
        {
          title: "养护单位",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "作业地点",
          key: "address",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "作业时间",
          key: "time2",
          minWidth: 100,
          maxWidth: 200,
        },
        { title: "作业内容", key: "itemList2", maxWidth: 300, minWidth: 100 },
        { title: "作业人数", key: "peopleNum", maxWidth: 300, minWidth: 100 },
        { title: "监管人员", key: "supervisor", maxWidth: 300, minWidth: 100 },

        {
          title: "服务模块",
          key: "content",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "作业环节",
          key: "linkList2",
          minWidth: 100,
          maxWidth: 200,
          span: 24,
        },
        {
          title: "危险因素",
          key: "factorList2",
          minWidth: 100,
          maxWidth: 200,
          span: 24,
        },
        {
          title: "采取措施",
          key: "measureList2",
          minWidth: 100,
          maxWidth: 200,
          span: 24,
        },
        /*   {
          title: "是否交底",
          key: "isHandover2",
          required: true,
          minWidth: 100,
          maxWidth: 200,
        }, */
        {
          title: "交底文件",
          key: "handoverFileList",
          slot: "jiaodi",
          show: "photo",
          minWidth: 100,
          maxWidth: 200,
          span: 24,
        },
        {
          title: "审批附件",
          key: "approveFileList",
          span: 24,
          slot: "shenpi",
          show: "photo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "是否办结",
          key: "isFinish2",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "流程图片",
          slot: "action",
          key: "fileList",
          show: "photo",
          span: 24,
          maxWidth: 300,
          minWidth: 100,
        },
      ],
      tableData: [],

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      selectTableData: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-rpt/apply/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].time2 = this.utils.time(data[i].startTime, "yymmdd");
          data[i].measureList2 = data[i].measureList.join(" / ");
          data[i].factorList2 = data[i].factorList.join(" / ");
          data[i].linkList2 = data[i].linkList.join(" / ");
          data[i].itemList2 = data[i].itemList.join(" / ");
          data[i].isFinish2 = this.$t("bool." + data[i].isFinish);
          data[i].isHandover2 = this.$t("bool." + data[i].isHandover);
        }
        this.tableData = data;
        console.log(data);
      });
    },
    detail(row) {
      var a = this.selectTableData;
      for (let i = 0; i < a.length; i++) {
        this.utils.loading(this, "加载中");
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-rmm-server-dpm/apply/item",
          data: { no: a[i].workNo },
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          a[i].qianzi = res.data.data.signList;
          if (i == this.selectTableData.length - 1) {
            this.$refs.dayin.reach(this.selectTableData, this.columns);
          }
        });
      }
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.getList();
    },
    dayin() {
      if (this.selectTableData.length == 0) {
        this.$Message.error("请选择条目");
        return;
      }
      this.detail();
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yanghuzuoyechaxun/gaoweishenqing.vue